import { render } from "./CardUserInfoForm.vue?vue&type=template&id=029bf785&scoped=true"
import script from "./CardUserInfoForm.vue?vue&type=script&lang=js"
export * from "./CardUserInfoForm.vue?vue&type=script&lang=js"

import "./CardUserInfoForm.vue?vue&type=style&index=0&id=029bf785&scoped=true&lang=css"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029bf785"]])

export default __exports__